import { Grid, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import type { ID } from "../../data/BaseEntity";
import { useCustomerCalculationsStats } from "./useCustomerCalculationsStats";

interface StatsForTypeProps {
  readonly name: string;
  readonly count: number;
}

const StatsForType: FC<StatsForTypeProps> = ({ name, count }) => (
  <Grid container size={12}>
    <Grid size={6}>
      <Typography variant="subtitle2">{name}</Typography>
    </Grid>
    <Grid size={6}>
      <Typography variant="subtitle2">{count}</Typography>
    </Grid>
  </Grid>
);

interface Props {
  readonly customerId: ID;
  readonly year: number;
}

const CustomerCalculationsStats: FC<Props> = ({ customerId, year }) => {
  const { calculationsStats, isLoading } = useCustomerCalculationsStats(customerId, year);
  if (isLoading) {
    return (
      <Grid container data-testid="customer-calculation-stats">
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }
  if (!calculationsStats) {
    return <Grid container data-testid="customer-calculation-stats" />;
  }

  return (
    <Grid
      container
      data-testid="customer-calculation-stats"
      sx={{
        rowGap: 2,
      }}
    >
      <StatsForType name="Wygenerowane" count={calculationsStats.generatedCount} />
      <StatsForType name="Wygenerowane przez klienta" count={calculationsStats.generatedByCustomerCount} />
    </Grid>
  );
};

export default CustomerCalculationsStats;
